import React from 'react';

import { ExecutionHistoryContext } from '@qality/common-components/src/lib/ExecutionHistoryProvider';
import { FailedSteps } from '@qality/common-components/src/test-execution/failed-steps';
import { ReportedBugs } from '@qality/common-components/src/test-execution/reported-bugs';

import { PreviousTestExecutionsView } from './PreviousTestExecutions.view';

export const PreviousTestExecutions = (): JSX.Element => {
  const { currentTab, handleChangeTab } = React.useContext(
    ExecutionHistoryContext
  );

  return (
    <PreviousTestExecutionsView
      currentTab={currentTab}
      title='Past executions'
      onClickTab={handleChangeTab}
    >
      {currentTab === 'reported-bugs' && <ReportedBugs />}
      {currentTab === 'failed-steps' && <FailedSteps />}
    </PreviousTestExecutionsView>
  );
};
